import React from 'react'
import './Services.css'
import Coding from "../../img/coding.png"
import Blender from "../../img/blender.png"
import Card from '../Card/Card'
import Glasses from '../../img/glassesimoji.png'
import Resume from './Resume.pdf'
import { useContext } from "react";
import { themeContext } from '../../Context';
import { motion } from 'framer-motion';
const Services = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <div className="services" id='Services'>
        {/*Left Side */}
        <div className="s-left">
            <span style = {{color : darkMode? 'white': ''}}>My Awesome</span>
            <span>Services</span>
            <span style = {{color : darkMode? 'white': ''}}>
            I offer a range of services to help clients bring their digital projects to life. 
            <br/>
            From creating dynamic websites to designing eye-catching 3D models, 
            <br/>
            I bring creativity and technical expertise to every project I work on.
            </span>
            <a href={Resume} download>
            <button className=" button s-button">Download CV</button>
            </a>
            
            <div className="blur s-blur" style={{background: "#ABF1FF94"}} ></div>
        </div>

        {/*Right Side */}
        <div className="s-right">

            {/*1ST CARD */}
            <motion.div
            whileInView={{left: '-14rem'}}
            initial={{left: '-14rem'}}
            animate={{left: '14rem'}}
            transition={{duration: 7, type: 'spring'}}
            style={{left: '14rem' }} >
            <Card
                emoji = {Coding}
                heading = {'Development'}
                details = {"E-commerce websites, Business, Portfolios, Blogs, Mobile Apps and many more"}
                
                />
            </motion.div>

            {/*2ND CARD */}
            <motion.div
            animate={{left: '-4rem'}}
            initial={{left: '4rem'}}
            whileInView={{left: '-4rem'}}
            transition={{duration: 7, type: 'spring'}}
            style={{left: '-4rem',top:'12rem'}}>
            <Card
                emoji = {Blender}
                heading = {'3D Modeling & Animation'}
                details = {"Product Design, 3D Logo,Cover Art, Animations,3D Motion Graphic"}
                />
            </motion.div>

            {/*3RD CARD */}
            <motion.div
            animate={{left: '12rem'}}
            initial={{left: '4rem'}}
            whileInView={{left: '12rem'}}
            transition={{duration: 7, type: 'spring'}}
             style={{left: '12rem',top:'19rem'}}>
            <Card
                emoji = {Glasses}
                heading = {'Architectural Visualiztion'}
                details = {"Interior Design, Exterior Design, Landscapes, Game Environment, Walkthrough Animations"}
                />
            </motion.div>

            <div className="blur s-blur2"  style={{background: "var(--purple)"}}></div>
            <div className="blur s-blur1"  style={{background: "#C1F5FF"}}></div>
        </div>
    </div>
  )
}

export default Services